import { Injectable } from '@angular/core';
import { AppConfig, UvExplorerClient } from 'common';
import { Observable, Subject } from 'rxjs/Rx';
import { ViewerDeviceGroupTreeDto, ViewerDeviceGroupContainerDto, ViewerDeviceGroupDto } from 'UvExplorerServer.Dtos.TS/Viewer';
import { ValueEncoder } from "DiscoveryEngine.TS/Utils";
import { UpdateResultDto } from "UvExplorerServer.Dtos.TS";

@Injectable()
export class DeviceGroupWebService {
	constructor(private appConfig: AppConfig, private uvExplorerClient: UvExplorerClient) {
		return;
	}

	public getViewerDeviceGroupTree(scopeGuid: string): Observable<ViewerDeviceGroupTreeDto> {
		let url = this.appConfig.dataServiceUrl + `api/data/viewerdevicegrouptree/${scopeGuid}`;
		return this.uvExplorerClient.getObjSer<ViewerDeviceGroupTreeDto>(url, ViewerDeviceGroupTreeDto);
	}

	//
	// ViewerDeviceGroupContainers
	//

	public getViewerDeviceGroupContainerByGuid(guid: string): Observable<ViewerDeviceGroupContainerDto> {
		let url = this.appConfig.configServiceUrl + `api/config/viewerdevicegroupcontainers/guid/${guid}`;
		return this.uvExplorerClient.getObjSer<ViewerDeviceGroupContainerDto>(url, ViewerDeviceGroupContainerDto);
	}

	public createViewerDeviceGroupContainer(vdgc: ViewerDeviceGroupContainerDto, parentGuid: string, position: number): Observable<ViewerDeviceGroupContainerDto> {

		let body = {
			create_vdgc_request: {
				parent_guid: parentGuid,
				position: ValueEncoder.EncodeInteger(position)
			}
		};

		vdgc.Write(body.create_vdgc_request, {});

		let url = this.appConfig.configServiceUrl + `api/config/viewerdevicegroupcontainers`;
		let subject = new Subject<ViewerDeviceGroupContainerDto>();

		this.uvExplorerClient.postObjSer<UpdateResultDto>(url, body, UpdateResultDto).subscribe(
			(result: UpdateResultDto) => {
				vdgc.CopyProps(result, true);
				subject.next(vdgc);
			},
			(error?) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public updateViewerDeviceGroupContainer(vdgc: ViewerDeviceGroupContainerDto): Observable<ViewerDeviceGroupContainerDto> {
		let body = {};
		vdgc.Write(body, {});

		let url = this.appConfig.configServiceUrl + `api/config/viewerdevicegroupcontainers`;
		let subject = new Subject<ViewerDeviceGroupContainerDto>();

		this.uvExplorerClient.putObjSer<UpdateResultDto>(url, body, UpdateResultDto).subscribe(
			(result: UpdateResultDto) => {
				vdgc.CopyProps(result, false);
				subject.next(vdgc);
			},
			(error?) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public deleteViewerDeviceGroupContainerByGuid(scopeGuid: string, guid: string): Observable<boolean> {
		let body = {
			delete_vdgc_by_guid_request: {
				scope_guid: scopeGuid,
				vdgc_guid: guid
			}
		};

		let url = this.appConfig.configServiceUrl + `api/config/viewerdevicegroupcontainers/guid`;
		return this.uvExplorerClient.deleteNoResult(url, body);
	}

	//
	// ViewerDeviceGroups
	//

	public getViewerDeviceGroupByGuid(guid: string): Observable<ViewerDeviceGroupDto> {
		let url = this.appConfig.configServiceUrl + `api/config/viewerdevicegroups/guid/${guid}`;
		return this.uvExplorerClient.getObjSer<ViewerDeviceGroupDto>(url, ViewerDeviceGroupDto);
	}

	public createViewerDeviceGroup(vdg: ViewerDeviceGroupDto, parentGuid: string, position: number): Observable<ViewerDeviceGroupDto> {
		let body = {
			create_vdg_request: {
				parent_guid: parentGuid,
				position: ValueEncoder.EncodeInteger(position)
			}
		};

		vdg.Write(body.create_vdg_request, {});

		let url = this.appConfig.configServiceUrl + `api/config/viewerdevicegroups`;
		let subject = new Subject<ViewerDeviceGroupDto>();

		this.uvExplorerClient.postObjSer<UpdateResultDto>(url, body, UpdateResultDto).subscribe(
			(result: UpdateResultDto) => {
				vdg.CopyProps(result, true);
				subject.next(vdg);
			},
			(error?) => {
				console.error(error);
				subject.error(error);
			}
		);

		return subject.asObservable();
	}

	public updateViewerDeviceGroup(vdg: ViewerDeviceGroupDto): Observable<ViewerDeviceGroupDto> {
		let body = {
			update_vdg_request: {
			}
		};
		vdg.Write(body.update_vdg_request, {});

		let url = this.appConfig.configServiceUrl + `api/config/viewerdevicegroups`;
		let subject = new Subject<ViewerDeviceGroupDto>();

		this.uvExplorerClient.putObjSer<UpdateResultDto>(url, body, UpdateResultDto).subscribe(
			(result: UpdateResultDto) => {
				vdg.CopyProps(result, false);
				subject.next(vdg);
			},
			(error?) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public deleteViewerDeviceGroupByGuid(netViewGuid: string, guid: string, parentGuid: string): Observable<boolean> {
		let body = {
			delete_vdg_by_guid_request: {
				net_view_guid: netViewGuid,
				vdg_guid: guid,
				parent_guid: parentGuid
			}
		};

		let url = this.appConfig.configServiceUrl + `api/config/viewerdevicegroups/guid`;
		return this.uvExplorerClient.deleteNoResult(url, body);
	}

}